import { useGlobal } from '@jimmyboys/liita-ui/dist/components/GlobalContext'
import styles from './HistoryDialog.module.sass'
import VStack from '@jimmyboys/liita-ui/dist/components/VStack'
import { TrustNotification } from 'models'
import { useFetchList } from 'store'
import HStack from '@jimmyboys/liita-ui/dist/components/HStack'
import Tooltip from '@jimmyboys/liita-ui/dist/components/Tooltip'
import Icon from '@jimmyboys/liita-ui/dist/components/Icon'

const NotificationItem = (props) => {
	const { item } = props
	const { i18n } = useGlobal()

	return (
		<>
			<HStack gap='small' className={styles['history-row']}>
				<VStack className={styles['date-column']}>
					<small>
						<strong>
							{item?.notificationDate?.dateTimeFormat}
						</strong>
					</small>
					<small>{i18n`by ${item?.userCreate?.name}`}</small>
				</VStack>
				<VStack gap='xsmall'>
					<small>
						<strong>{item?.notificationType}</strong>
					</small>
					<Tooltip text={item?.description || ''}>
						<small>{item?.description}</small>
					</Tooltip>
				</VStack>
			</HStack>
		</>
	)
}

const NotificationHistoryDialog = (props) => {
	const { data } = props
	const { processId } = data
	const { i18n } = useGlobal()

	const processNotificationsUri = `/clinical_processes/${processId}/all_notifications`
	const { contents, state } = useFetchList(
		[processNotificationsUri],
		[TrustNotification.fromJSON]
	)

	const [processNotifications] = contents
	processNotifications?.sort(
		(a, b) => b.notificationDate.timestamp - a.notificationDate.timestamp
	)

	const isLoading = state === 'loading'

	return !isLoading ? (
		<VStack className={styles['history-root']}>
			<VStack className={styles['history-container']}>
				{processNotifications?.map((item) => (
					<NotificationItem item={item} key={item.id} />
				))}
			</VStack>
		</VStack>
	) : (
		<VStack className={styles['center-content']} justify='space-between'>
			<Icon name='on-going' />
			<small>{i18n`Loading notifications history...`}</small>
		</VStack>
	)
}

export default NotificationHistoryDialog
